import { ModalForm } from 'modules/app/styles'
import { CurrentPlanInfo, PlanSelector } from './styles'
import { ReactComponent as CloseIcon } from 'assets/images/icons/close.svg'
import { ResumeplanMemberList } from 'modules/settings/styles'
import { CustomButton } from 'modules/auth/styles'
import { ReactComponent as ManagePlanIllustrator } from 'assets/images/manage_plan_illustration.svg'
import moment from 'moment'
import { ButtonLoader } from 'utils/storageUtils'
import { connect } from 'react-redux'
import { resumeSubscription_action, toggleCardModal_action, toggleResumePlanModal_action } from 'store/actions'
import { Modal, ModalBody } from 'reactstrap'

const ResumePlan = (props) => {
  const getNextInvoiceAmount = () => {
    return props.subscription.quantity * (props.subscription.plan.amount / 100)
  }
  const getNextInvoiceDate = () => {
    return moment().add(1, props.subscription.plan.interval).format('ll')
  }
  const submitResumePlan = async (e) => {
    e.preventDefault()
    if (!props.card.id) {
      props.toggleCardModal(true)
    } else {
      props.resumeSubscription()
    }
  }
  return (
    <Modal size='lg' isOpen={true} fade={false} centered toggle={() => props.toggleResumePlanModal(false)}>
      <ModalBody className='p-0'>
        <a
          href='/'
          className='modal-close'
          onClick={(e) => {
            e.preventDefault()
            props.toggleResumePlanModal(false)
          }}>
          <CloseIcon />
        </a>
        <ModalForm className='h-100 d-flex flex-wrap flex-md-nowrap' onSubmit={submitResumePlan} autoComplete='off'>
          <CurrentPlanInfo className='subscribed'>
            <div className='title'>Resume PRO Plan</div>
            <br />
            <div className='members-list p-0'>
              <h6 className='font-weight-600 mb-0'>Team members</h6>
              <ResumeplanMemberList size='sm' borderless>
                <tbody>
                  {props.active_users.map((user) => (
                    <tr key={user.id}>
                      <td className='pl-0 py-2'>{user.name}</td>
                      <td className='pl-0 py-2'>{user.email}</td>
                      <td className='pl-0 py-2 text-capitalize'>{user.user_type}</td>
                    </tr>
                  ))}
                </tbody>
              </ResumeplanMemberList>
            </div>
          </CurrentPlanInfo>
          <PlanSelector className='checkout'>
            <div className='checkout-illustrator mt-4'>
              <ManagePlanIllustrator />
            </div>
            <div className='plan-amount mb-2'>
              $<span className='amount'>{getNextInvoiceAmount()}</span>
              <span className='interval'>/{props.subscription.plan.interval === 'month' ? 'mo.' : 'yr.'}</span>
            </div>
            <div className='user-count mb-3'>Current {props.subscription.quantity} users</div>
            <ul className='mt-auto pl-3 mx-3 mx-sm-0' style={{ listStyleType: 'disc' }}>
              <li>
                Your next payment of ${getNextInvoiceAmount()} will be charged on {getNextInvoiceDate()}
              </li>
            </ul>
            <br />
            <div className='d-flex'>
              <CustomButton type='submit' className='black px-5 mr-3' disabled={props.isSubmittingSubscription || props.isSubmittingCard}>
                Resume {props.isSubmittingSubscription && <ButtonLoader />}
              </CustomButton>
              <CustomButton type='button' className='gray px-5 shadow-none' disabled={props.isSubmittingSubscription || props.isSubmittingCard} onClick={() => props.toggleResumePlanModal(false)}>
                Cancel
              </CustomButton>
            </div>
          </PlanSelector>
        </ModalForm>
      </ModalBody>
    </Modal>
  )
}
const mapStateToProps = (state) => ({
  user: state.auth.user,
  company: state.company.company,
  isSubmittingSubscription: state.subscription.isSubmittingSubscription,
  isSubmittingCard: state.subscription.isSubmittingCard,
  subscription: state.subscription.subscription
})

const mapDispatchToProps = (dispatch) => ({
  resumeSubscription: () => dispatch(resumeSubscription_action()),
  toggleResumePlanModal: (value) => dispatch(toggleResumePlanModal_action(value)),
  toggleCardModal: (value) => dispatch(toggleCardModal_action(value))
})

export default connect(mapStateToProps, mapDispatchToProps)(ResumePlan)
